import { Button } from "@/components/ui/button"
import { FormField } from "pages/GenericOrder/ui-form/form-field"
import { ModalForm } from "pages/GenericOrder/ui-form/modal-form"
import { useState } from "react"
import { useMutation, useQueryClient } from "react-query"
import { z } from "zod"
import { updateProductSingle } from "../apis"
import { toast } from "sonner"
import { useParams } from "react-router-dom"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { CurrencyInput } from "components/Input/Inputs"

const schema = z.object({
    quantity: z
      .number({
        invalid_type_error: 'Quantity is required',
        required_error: 'Quantity is required',
      })
      .min(1, 'Quantity must be at least 1')
      .refine(val => !isNaN(val), {
        message: 'Quantity must be a number',
      }),
    cardType: z.string().optional()
  })

type FieldValues = z.infer<typeof schema>

export default function EditProduct({children, product_id, currency, quantity, cardType}:{children: React.ReactNode, product_id:string, quantity: number, currency:string, cardType: 'multicurrency' | 'singlecurrency'}) {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const {id} = useParams()
    const queryClient = useQueryClient()
    const {mutate, isLoading} = useMutation({
        mutationFn:updateProductSingle,
        onSuccess:()=>{
            queryClient.invalidateQueries(['orderDetails'])
            toast.success('Product updated successfully')
            setIsOpen(false)
        },
        onError: ()=>{
            toast.error('Failed to update product')
        }
    })
    const handleSubmit = (data:FieldValues) =>{
        mutate({
            order_id: Number(id!),
            uuid: product_id,
            fx_amount: data?.quantity,
            card_type: data?.cardType
        })
    }
    const defaultValues = {
        quantity,
        cardType
    }
    console.log()
    return (
        <>
            <Button variant='ghost' className="p-0 h-min" onClick={()=>setIsOpen(true)}>
                {children}
            </Button>
            <ModalForm<FieldValues>
                title="Edit Product"
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                onSubmit={data=>handleSubmit(data)}
                submitButtonText="Save"                  
                schema={schema} 
                defaultValues={defaultValues}      
                isLoading={isLoading}                                                           
            >
                {
                    (form) => {
                        return (
                            <div className="py-4 space-y-2">
                                {
                                    cardType?.length > 0 &&
                                    <FormField
                                        form={form}                                        
                                        name='cardType'
                                        label="Select Card Type"
                                        render={({ field }) => (
                                            <Select disabled onValueChange={field.onChange} defaultValue={cardType}>
                                                <SelectTrigger>
                                                    <SelectValue placeholder="Select a card type" />
                                                </SelectTrigger>
                                                <SelectContent>
                                                    <SelectItem value="multicurrency">Multi Currency</SelectItem>
                                                    <SelectItem value="singlecurrency">Single Currency</SelectItem>
                                                </SelectContent>
                                            </Select>
                                        )}
                                    />
                                }
                                <FormField
                                    form={form}                                    
                                    name='quantity'
                                    label="Enter quantity"                                    
                                    render={({ field }) => (
                                       <CurrencyInput
                                            field={{ ...field, onChange: e => field.onChange(parseInt(e.target.value, 10)) }}
                                            currencyType={currency}
                                        />
                                    )}                                                                                                                                            
                                />
                            </div>
                        )
                    }
                }
            </ModalForm>
        </>
    )
}